export default {
    login: async function (params) {
        let option = {
            url: '/api/v1/user/login',
            type: 'post',
            params: params,
            mock: {
                state: false,
                data: {}
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
    changeUserPwd: async function (params) {
        let option = {
            url: '/api/v1/user/info',
            type: 'post',
            params: params,
            mock: {
                state: false,
                data: {}
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
    changeAdminPwd: async function (params) {
        let option = {
            url: '/api/v1/partner/info',
            type: 'post',
            params: params,
            mock: {
                state: false,
                data: {}
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
    changeAdminInfo: async function (params) {
        let option = {
            url: '/api/v1/partner/info',
            type: 'put',
            params: params,
            mock: {
                state: false,
                data: {}
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
    getAdminInfo: async function (params) {
        let option = {
            url: '/api/v1/partner/self_info',
            type: 'get',
            params: params,
            mock: {
                state: false,
                data: {}
            }
        }
        return await this.$api.handleRequest.call(this, option);
    },
}